/**
 * Determines if labor ticket flow is enabled for the current machine and operator.
 *
 * Labor ticket flow requires:
 * - Job labor tracking to be enabled (labor tickets + ERP mapping)
 * - APM (Advanced Performance Management) to be disabled
 * - Current operator to have an ERP ID assigned
 *
 * This enables operators to clock in/out of work with labor ticket tracking.
 */
import { useSelector } from 'react-redux';
import { getCurrentOperator } from 'lib/selectors/getCurrentOperator';
import { getIsAPMEnabled } from 'lib/selectors/getIsAPMEnabled';
import { getIsJobLaborTrackingEnabled } from 'lib/selectors/getIsJobLaborTrackingEnabled';

const useIsLaborTicketFlow = () => {
  const operator = useSelector(getCurrentOperator);
  const isAPMEnabled = useSelector(getIsAPMEnabled);
  const isJobLaborTrackingEnabled = useSelector(getIsJobLaborTrackingEnabled);

  return !!(isJobLaborTrackingEnabled && !isAPMEnabled && operator?.erpId);
};

export { useIsLaborTicketFlow };
